const isRefInViewport = _ref => {
  let {
    offsetScroll,
    refHeight,
    refRect,
    windowObj
  } = _ref;
  return refRect.top + refHeight >= 0 && refRect.left >= 0 && refRect.bottom + offsetScroll <= windowObj.innerHeight && Math.floor(refRect.right) <= windowObj.innerWidth;
};
const isScrolledPastOffset = (offsetScroll, windowObj) => {
  return windowObj.pageYOffset >= offsetScroll;
};
const applyInlineOffsetMargin = (animation, offsetMargin, position, stickyType, isVisible) => {
  const check = parseInt(offsetMargin, 10);
  if (!check) return {};
  const topStyle = check && position === 'top' && isVisible ? {
    top: `${offsetMargin}px`
  } : null;
  const bottomStyle = check && position === 'bottom' && isVisible ? {
    bottom: `${offsetMargin}px`
  } : null;
  return topStyle || bottomStyle || {};
};
const getPosition = ref => {
  var _ref$current, _ref$current2;
  if (!ref) return null;
  const pageOffset = window.pageYOffset;
  return {
    bottomOffset: pageOffset + ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect().bottom),
    topOffset: pageOffset + ((_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.getBoundingClientRect().top)
  };
};
const getScrollPosition = windowObj => {
  var _document, _document$documentEle;
  return (windowObj === null || windowObj === void 0 ? void 0 : windowObj.pageYOffset) || ((_document = document) === null || _document === void 0 ? void 0 : (_document$documentEle = _document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop);
};
const isScrolledPastContent = (windowObj, yPosition) => {
  return getScrollPosition(windowObj) > yPosition && yPosition > 0;
};
const isScrollingDown = (currentScrollPosition, lastScrollPosition) => {
  return currentScrollPosition > lastScrollPosition;
};
export { applyInlineOffsetMargin, getScrollPosition, getPosition, isRefInViewport, isScrolledPastContent, isScrolledPastOffset, isScrollingDown };
//# sourceMappingURL=helpers.js.map